<!--
・その他、新品、中古で表示をカテゴライズする
・searchwordの引数をオブジェクトへ変更。wordは従来のもの、それ以外はパラメータをつけて検索ページへ遷移させる
-->

<template>
<div class="searchHistory">
  <!-- <vs-button color="primary" type="filled" @click="getSearchHistory()">Amazon</vs-button> -->
  	<template v-if="searchHistoryArr.length > 0">
	  	<template v-for="items in searchHistoryArr">
	  		<h3 class="search-date">{{items[0].searchDate | momentY}}</h3>
			<table stripe class="vs-table vs-table--tbody-table mt-3 mb-8" v-if="items.length > 0">
				<tbody>
					<tr class="tr-values vs-table--tr tr-table-state-null hover:text-primary cursor-pointer" @click="searchWord(item)" v-for="item in items">
						<th class="date">{{item.searchDate | momentH}}</th>
						<!-- <td class="td vs-table--td title">{{item.searchWord}}</td> -->
						<td class="td vs-table--td title">
							<template v-if="typeof item.searchOption == 'undefined'">
								{{item.searchWord}}
							</template>
							<template v-else>
								<div class="result-wrapper">
									<div class="result-inner">
										<div v-if="typeof item.searchWord != 'undefined'" class="result-wrap">
											<span class="result-ttl">キーワード</span>
											<span class="result">
												<template v-if="item.searchWord == ''">-</template>
												<template v-else>{{item.searchWord}}</template>
											</span>
										</div>

										<div v-if="typeof item.searchOption.category != 'undefined'" class="result-wrap">
											<span class="result-ttl">カテゴリ</span>
									        <span class="result">{{item.searchOption.category.label}}</span>
										</div>

										<div v-if="typeof item.searchOption.is_Amazon_outOfStock != 'undefined' && item.searchOption.is_Amazon_outOfStock != 0" class="result-wrap">
											<span class="result-ttl">Amazon在庫</span>
											<span class="result">除外する</span>
										</div>

										<div v-if="(typeof item.searchOption.current_SALES_gte != 'undefined' && item.searchOption.current_SALES_gte != null && item.searchOption.current_SALES_gte != '') || (typeof item.searchOption.current_SALES_lte != 'undefined' && item.searchOption.current_SALES_lte != null && item.searchOption.current_SALES_lte != '')"  class="result-wrap">
											<span class="result-ttl">ランキング</span>
									        <template v-if="typeof item.searchOption.current_SALES_gte != 'undefined' && item.searchOption.current_SALES_gte != null && item.searchOption.current_SALES_gte != ''">
									        	<span class="result">{{item.searchOption.current_SALES_gte.toLocaleString()}}</span>
											</template>
									        <template v-if="typeof item.searchOption.current_SALES_lte != 'undefined' && item.searchOption.current_SALES_lte != null && item.searchOption.current_SALES_lte != ''">
									        	<span class="item">〜</span>
									        	<span class="result">{{item.searchOption.current_SALES_lte.toLocaleString()}}</span>
											</template>
											<span class="item">位</span>
										</div>
									</div>

									<div class="result-inner">
										<div v-if="(typeof item.searchOption.current_NEW_gte != 'undefined' && item.searchOption.current_NEW_gte != null && item.searchOption.current_NEW_gte != '') || (typeof item.searchOption.current_NEW_lte != 'undefined' && item.searchOption.current_NEW_lte != null && item.searchOption.current_NEW_lte != '')" class="result-wrap">
											<span class="result-ttl"><span class="color-new">新品</span> 価格</span>
									        <template v-if="typeof item.searchOption.current_NEW_gte != 'undefined' && item.searchOption.current_NEW_gte != null && item.searchOption.current_NEW_gte != ''">
									        	<span class="result">{{item.searchOption.current_NEW_gte.toLocaleString()}}</span>
											</template>
									        <template v-if="typeof item.searchOption.current_NEW_lte != 'undefined' && item.searchOption.current_NEW_lte != null && item.searchOption.current_NEW_lte != ''">
									        	<span class="item">〜</span>
									        	<span class="result">{{item.searchOption.current_NEW_lte.toLocaleString()}}</span>
											</template>
											<span class="item">円</span>
										</div>

										<div v-if="(typeof item.searchOption.deltaPercent90_NEW_gte != 'undefined' && item.searchOption.deltaPercent90_NEW_gte != '' && item.searchOption.deltaPercent90_NEW_gte != null) || (typeof item.searchOption.deltaPercent90_NEW_lte != 'undefined' && item.searchOption.deltaPercent90_NEW_lte != '' && item.searchOption.deltaPercent90_NEW_lte != null)" class="result-wrap">
											<span class="result-ttl"><span class="color-new">新品</span> 90日間の値下り / 値上り率</span>
									        <template v-if="typeof item.searchOption.deltaPercent90_NEW_gte != 'undefined' && item.searchOption.deltaPercent90_NEW_gte != '' && item.searchOption.deltaPercent90_NEW_gte != null">
									        	<span class="result">{{item.searchOption.deltaPercent90_NEW_gte}}</span>
											</template>
									        <template v-if="typeof item.searchOption.deltaPercent90_NEW_lte != 'undefined' && item.searchOption.deltaPercent90_NEW_lte != '' && item.searchOption.deltaPercent90_NEW_lte != null">
									        	<span class="item">〜</span>
									        	<span class="result">{{item.searchOption.deltaPercent90_NEW_lte}}</span>
											</template>
											<span class="item">％</span>
										</div>

										<div v-if="(typeof item.searchOption.current_COUNT_NEW_gte != 'undefined' && item.searchOption.current_COUNT_NEW_gte != '' && item.searchOption.current_COUNT_NEW_gte != null) || (typeof item.searchOption.current_COUNT_NEW_lte != 'undefined' && item.searchOption.current_COUNT_NEW_lte != '' && item.searchOption.current_COUNT_NEW_lte != null)" class="result-wrap">
											<span class="result-ttl"><span class="color-new">新品</span> 出品者数</span>
									        <template v-if="typeof item.searchOption.current_COUNT_NEW_gte != 'undefined' && item.searchOption.current_COUNT_NEW_gte != '' && item.searchOption.current_COUNT_NEW_gte != null">
									        	<span class="result">{{item.searchOption.current_COUNT_NEW_gte.toLocaleString()}}</span>
											</template>
									        <template v-if="typeof item.searchOption.current_COUNT_NEW_lte != 'undefined' && item.searchOption.current_COUNT_NEW_lte != '' && item.searchOption.current_COUNT_NEW_lte != null">
									        	<span class="item">〜</span>
									        	<span class="result">{{item.searchOption.current_COUNT_NEW_lte.toLocaleString()}}</span>
											</template>
											<span class="item">人</span>
										</div>

										<div v-if="typeof item.searchOption.is_New_outOfStock != 'undefined' && item.searchOption.is_New_outOfStock != 0" class="result-wrap">
											<span class="result-ttl"><span class="color-new">新品 </span>在庫</span>
											<span class="result">なし</span>
										</div>
									</div>

									<div class="result-inner">
										<div v-if="(typeof item.searchOption.current_USED_gte != 'undefined' && item.searchOption.current_USED_gte != '' && item.searchOption.current_USED_gte != null) || (typeof item.searchOption.current_USED_lte != 'undefined' && item.searchOption.current_USED_lte != '' && item.searchOption.current_USED_lte != null)" class="result-wrap">
											<span class="result-ttl"><span class="color-used">中古</span> 価格</span>
									        <template v-if="typeof item.searchOption.current_USED_gte != 'undefined' && item.searchOption.current_USED_gte != '' && item.searchOption.current_USED_gte != null">
									        	<span class="result">{{item.searchOption.current_USED_gte.toLocaleString()}}</span>
											</template>
									        <template v-if="typeof item.searchOption.current_USED_lte != 'undefined' && item.searchOption.current_USED_lte != '' && item.searchOption.current_USED_lte != null">
									        	<span class="item">〜</span>
									        	<span class="result">{{item.searchOption.current_USED_lte.toLocaleString()}}</span>
											</template>
											<span class="item">円</span>
										</div>

										<div v-if="(typeof item.searchOption.deltaPercent90_USED_gte != 'undefined' && item.searchOption.deltaPercent90_USED_gte != '' && item.searchOption.deltaPercent90_USED_gte != null) || (typeof item.searchOption.deltaPercent90_USED_lte != 'undefined' && item.searchOption.deltaPercent90_USED_lte != '' && item.searchOption.deltaPercent90_USED_lte != null)" class="result-wrap">
											<span class="result-ttl"><span class="color-used">中古</span> 90日間の値下り / 値上り率</span>
									        <template v-if="typeof item.searchOption.deltaPercent90_USED_gte != 'undefined' && item.searchOption.deltaPercent90_USED_gte != '' && item.searchOption.deltaPercent90_USED_gte != null">
									        	<span class="result">{{item.searchOption.deltaPercent90_USED_gte}}</span>
											</template>
									        <template v-if="typeof item.searchOption.deltaPercent90_USED_lte != 'undefined' && item.searchOption.deltaPercent90_USED_lte != '' && item.searchOption.deltaPercent90_USED_lte != null">
									        	<span class="item">〜</span>
									        	<span class="result">{{item.searchOption.deltaPercent90_USED_lte}}</span>
											</template>
											<span class="item">％</span>
										</div>

										<div v-if="(typeof item.searchOption.current_COUNT_USED_gte != 'undefined' && item.searchOption.current_COUNT_USED_gte != '' && item.searchOption.current_COUNT_USED_gte != null) || (typeof item.searchOption.current_COUNT_USED_lte != 'undefined' && item.searchOption.current_COUNT_USED_lte != '' && item.searchOption.current_COUNT_USED_lte != null)" class="result-wrap">
											<span class="result-ttl"><span class="color-used">中古</span> 出品者数</span>
									        <template v-if="typeof item.searchOption.current_COUNT_USED_gte != 'undefined' && item.searchOption.current_COUNT_USED_gte != '' && item.searchOption.current_COUNT_USED_gte != null">
									        	<span class="result">{{item.searchOption.current_COUNT_USED_gte.toLocaleString()}}</span>
											</template>
									        <template v-if="typeof item.searchOption.current_COUNT_USED_lte != 'undefined' && item.searchOption.current_COUNT_USED_lte != '' && item.searchOption.current_COUNT_USED_lte != null">
									        	<span class="item">〜</span>
									        	<span class="result">{{item.searchOption.current_COUNT_USED_lte.toLocaleString()}}</span>
											</template>
											<span class="item">人</span>
										</div>

										<div v-if="typeof item.searchOption.is_Used_outOfStock != 'undefined' && item.searchOption.is_Used_outOfStock != 0" class="result-wrap">
											<span class="result-ttl"><span class="color-used">中古</span> 在庫</span>
											<span class="result">なし</span>
										</div>
									</div>
								</div>
							</template>
						</td>
					</tr>
				</tbody>
			</table>
		</template>
	</template>
</div>
</template>
<script>
//import ItemListView from './components/ItemListView.vue'
import firebase from 'firebase/app'
import moment from 'moment'

export default {
	name: 'searchHistory',
	components: {
		//ItemListView
	},
	data () {
		return{
			readFirebaseItem: this.$route.meta.readFirebaseItem, // 現在のページ位置
			searchHistoryArr: [], // 検索履歴,
			searchCategory: [],   // カテゴリの一蘭
		}
	},
	watch: {
		"$route"() {
			this.readFirebaseItem = this.$route.meta.readFirebaseItem
		}
	},
	methods: {
		// ■ 検索履歴の呼び出し
		getSearchHistory() {
			const firebaseCurrentUser = firebase.auth().currentUser
			const dbUserSearchHistoryRef = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/searchHistory')
			const self = this
			dbUserSearchHistoryRef.on('value', function(snapshot) {
				//console.log('load db')
				/*
			 	for (let key in snapshot.val()) {
					self.searchHistoryArr.unshift(snapshot.val()[key])
			 	}
			 	console.log(self.searchHistoryArr)
				*/
			 	let formationArr = []
			 	let formationCheck = []
			 	let count = 0
			 	for (let key in snapshot.val()) {
			 		// 
			 		let save = moment(snapshot.val()[key].searchDate).format('YYYY/MM/DD')
			 		//console.log('save')
			 		//console.log(save)

			 		//formationArr[save].unshift(snapshot.val()[key])
			 		if (formationCheck.indexOf(save) === -1) {
			 			formationArr[save] = []
			 			//console.log('formationArr')
			 			//console.log(formationArr)
			 			//formationArr[save].unshift(snapshot.val()[key])
			 		}
			 		formationArr[save].unshift(snapshot.val()[key])

			 		// 日付をチェック用配列に保存
			 		formationCheck.push(save)
			 	}
			 	for (let key in formationArr) {
			 		self.searchHistoryArr.unshift(formationArr[key])
			 	}
			 	//console.log(self.searchHistoryArr)
			 	self.$vs.loading.close()

			}, function (errorObject) {
			 	console.log("The read failed: " + errorObject.code)
			});
		},

		// ■ 引数の文字を検索する
		searchWord(obj) {
			//console.log(obj)
			let option = {}
			// 検索ワード
			if (typeof obj.searchWord != 'undefined') {
				option.s = obj.searchWord
			}
			// カテゴリ
			if (typeof obj.searchOption.category != 'undefined') {
				option.cat = obj.searchOption.category.label
			}
			// Amazon在庫を除外
			if (typeof obj.searchOption.is_Amazon_outOfStock != 'undefined' && obj.searchOption.is_Amazon_outOfStock != 0) {
				option.as = 1
			}
			// ランキング 以上
			if (typeof obj.searchOption.current_SALES_gte != 'undefined') {
				option.rg = obj.searchOption.current_SALES_gte
			}
			// ランキング 以内
			if (typeof obj.searchOption.current_SALES_lte != 'undefined') {
				option.rl = obj.searchOption.current_SALES_lte
			}
			// 新品価格(円) 以上
			if (typeof obj.searchOption.current_NEW_gte != 'undefined') {
				option.ng = obj.searchOption.current_NEW_gte
			}
			// 新品価格(円) 以下
			if (typeof obj.searchOption.current_NEW_lte != 'undefined') {
				option.nl = obj.searchOption.current_NEW_lte
			}
			// 新品 90日間の値下り / 値上り率(%) 以上
			if (typeof obj.searchOption.deltaPercent90_NEW_gte != 'undefined') {
				option.npg = obj.searchOption.deltaPercent90_NEW_gte
			}
			// 新品 90日間の値下り / 値上り率(%) 以下
			if (typeof obj.searchOption.deltaPercent90_NEW_lte != 'undefined') {
				option.npl = obj.searchOption.deltaPercent90_NEW_lte
			}
			// 新品出品者数 以上
			if (typeof obj.searchOption.current_COUNT_NEW_gte != 'undefined') {
				option.ncg = obj.searchOption.current_COUNT_NEW_gte
			}
			// 新品出品者数 以下
			if (typeof obj.searchOption.current_COUNT_NEW_lte != 'undefined') {
				option.ncl = obj.searchOption.current_COUNT_NEW_lte
			}
			// 新品在庫なし
			if (typeof obj.searchOption.is_New_outOfStock != 'undefined' && obj.searchOption.is_New_outOfStock != 0) {
				option.ns = 1
			}
			// 中古価格(円) 以上
			if (typeof obj.searchOption.current_USED_gte != 'undefined') {
				option.ug = obj.searchOption.current_USED_gte
			}
			// 中古価格(円) 以下
			if (typeof obj.searchOption.current_USED_lte != 'undefined') {
				option.ul = obj.searchOption.current_USED_lte
			}
			// 中古 90日間の値下り / 値上り率(%) 以上
			if (typeof obj.searchOption.deltaPercent90_USED_gte != 'undefined') {
				option.upg = obj.searchOption.deltaPercent90_USED_gte
			}
			// 中古 90日間の値下り / 値上り率(%) 以下
			if (typeof obj.searchOption.deltaPercent90_USED_lte != 'undefined') {
				option.upl = obj.searchOption.deltaPercent90_USED_lte
			}
			// 中古出品者数 以上
			if (typeof obj.searchOption.current_COUNT_USED_gte != 'undefined') {
				option.ucg = obj.searchOption.current_COUNT_USED_gte
			}
			// 中古出品者数 以下
			if (typeof obj.searchOption.current_COUNT_USED_lte != 'undefined') {
				option.ucl = obj.searchOption.current_COUNT_USED_lte
			}
			// 中古在庫なし
			if (typeof obj.searchOption.is_Used_outOfStock != 'undefined' && obj.searchOption.is_Used_outOfStock != 0) {
				option.us = 1
			}

			// 検索フラグ
			option.son = 1

	        
			// 検索ページへリダイレクト
			this.$router.push( { name: 'search', query: option } )
		},
		// ■ 詳細検索用のカテゴリを取得する
	    async getCategory(){
	    	this.$vs.loading()
			const self = this
			// カテゴリの取得
			var getCategoryList = firebase.functions().httpsCallable('getCategoryList')
			const result = await getCategoryList()
			if (result.data.length > 0) {
				for (var j = 0; result.data.length > j; j++) {
					let item = {}
					item.label = result.data[j].name
					item.id = result.data[j].cid
					item.value = result.data[j].cid
					item.count = result.data[j].productCount
					self.searchCategory.push(item)
				}
			}
			this.$vs.loading.close()
	    },
	},
	created() {
		const appLoading = document.getElementById('app')
		appLoading.classList.remove("login-view")
		// 他コントローラからのイベントの登録
		// ■ 検索履歴の追加
		/*
		this.$EventBus.$on('addSearchHistory', data => {
	      this.addSearchHistory(data)
	    })
	    */
	    // カテゴリを取得
	    //this.getCategory()
	},
	mounted: function(){
		// ■ 履歴を取得する
		this.getSearchHistory()
    	//this.$EventBus.$emit('searchStop',true)
	},
	filters: {
		moment: function (date) {
			return moment(date).format('YYYY / MM / DD HH:mm')
		},
		momentY: function (date) {
			return moment(date).format('YYYY / MM / DD')
		},
		momentH: function (date) {
			return moment(date).format('HH:mm')
		},
	}
}
</script>

<style lang="scss" scoped>
.vs-table{
	table-layout: fixed;
	border-radius: .5rem;
	border:none !important;
	background: #fff;
	tr{
		display:flex;
		position: relative;
		background-color:transparent;
		//border-top:1px solid #ccc;
		font-size: 16px;
		&:before{
			content:"";
			display:block;
			position:absolute;
			top:0;
			left:50%;
			transform: translateX(-50%);
			width:calc(100% - 20px);
			border-top:1px solid #ccc;
		}
		&:first-child{
			&:before{
				display:none;
			}
		}
	}
	th,td{
		position: relative;
		/*
		
		*/
	}
	th{
		padding: 12px 10px;
	}
	.date{
		width:60px;
		letter-spacing: 0.1em;
		line-height: 1.9;
	}
	.title{
		width:calc(100% - 60px);
		//line-height:1.8;
		.result{
			//margin-right:20px;
		}

		.item{
			margin-left:5px;
			margin-right:5px;
		}
	}
}
.result-wrapper{
	display: flex;
	flex-wrap:wrap;
	.result-inner{
		display: flex;
		flex-wrap:wrap;
		//width: 100%;
	}
	.result-wrap{
		display: flex;
		flex-wrap:wrap;
		align-items: baseline;
		align-content: center;
		margin-right:1.5rem;
		line-height:1.8;
		
		.result-ttl{
			font-size: 13px;
			&:before{
				content: "【";
			}
			&:after{
				content: "】";
			}
		}
		.item{
			font-size:13px;
		}
		.result{
			font-weight:bold;
			
		}
	}
}
.search-date{
	margin-top: 20px;
	//letter-spacing:.1em;
}
</style>